import { render } from "./PageNavigation.vue?vue&type=template&id=d75d9c30&scoped=true&ts=true"
import script from "./PageNavigation.vue?vue&type=script&lang=ts"
export * from "./PageNavigation.vue?vue&type=script&lang=ts"

import "./PageNavigation.vue?vue&type=style&index=0&id=d75d9c30&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d75d9c30"]])

export default __exports__